// timesheet
import axios from '@/libs/api.request'
export const getTimesheetPage = data => {
  return axios.request({
    url: '/timesheet/page',
    data,
    method: 'POST'
  })
}
export const getTimesheetSchedule = data => {
  return axios.request({
    url: '/timesheet/mentee/schedule',
    data,
    method: 'POST'
  })
}
export const getTimesheetSaveModule = data => {
  return axios.request({
    url: '/timesheet/save/module0',
    data,
    method: 'POST'
  })
}
export const getTimesheetMaterialSchedule = data => {
  return axios.request({
    url: '/timesheet/material/schedule',
    data,
    method: 'POST'
  })
}
